import { render, staticRenderFns } from "./contentCardBasePortraitE.vue?vue&type=template&id=234e0a7f&scoped=true"
import script from "./contentCardBasePortraitE.vue?vue&type=script&lang=js"
export * from "./contentCardBasePortraitE.vue?vue&type=script&lang=js"
import style0 from "./contentCardBasePortraitE.vue?vue&type=style&index=0&id=234e0a7f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234e0a7f",
  null
  
)

export default component.exports